import React, { useState, useEffect } from 'react';
import { Menu, X, Zap } from 'lucide-react';

export default function Header({ t }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-ink/85 backdrop-blur-xl border-b border-line shadow-card'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <a href="/" className="flex items-center gap-2 select-none group">
            <span className="w-9 h-9 rounded-xl bg-volt-400 flex items-center justify-center shadow-volt-glow group-hover:scale-105 transition-transform duration-200">
              <Zap size={20} strokeWidth={2.5} className="text-ink" fill="currentColor" />
            </span>
            <span className="font-display text-xl lg:text-2xl font-bold tracking-tight text-frost">
              Fit<span className="text-volt-400">upkeep</span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-mist">
            <a href="#platform" className="hover:text-volt-400 transition-colors">
              {t.header.navTraining}
            </a>
            <a href="#ernaehrung" className="hover:text-volt-400 transition-colors">
              {t.header.navErnaehrung}
            </a>
            <a href="/s" className="hover:text-volt-400 transition-colors">
              {t.header.navAbo}
            </a>
          </nav>

          <div className="hidden md:flex items-center">
            <a
              href="/s"
              className="px-6 py-2.5 rounded-full bg-volt-400 text-ink font-bold text-sm hover:bg-volt-300 hover:shadow-volt-glow transition-all duration-200 hover:-translate-y-0.5"
            >
              {t.header.cta}
            </a>
          </div>

          <button
            className="flex md:hidden p-2 rounded-lg text-mist hover:text-volt-400 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menü öffnen"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-abyss/95 backdrop-blur-xl border-t border-line px-4 py-4 flex flex-col gap-3">
          <a href="#platform" className="text-sm text-frost py-2" onClick={() => setMobileOpen(false)}>
            {t.header.navTraining}
          </a>
          <a href="#ernaehrung" className="text-sm text-frost py-2" onClick={() => setMobileOpen(false)}>
            {t.header.navErnaehrung}
          </a>
          <a
            href="/s"
            className="block w-full px-6 py-3 rounded-full bg-volt-400 text-ink font-bold text-sm text-center hover:bg-volt-300 transition-all duration-200"
            onClick={() => setMobileOpen(false)}
          >
            {t.header.cta}
          </a>
        </div>
      )}
    </header>
  );
}
